// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Legacy footer styles - kept for reference */
/* .footer {
  background-color: white;
  padding: 18px;
  height: 18px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -1px 1px -1px gray;
  display: flex;
  z-index: 1000;
} */

/* Custom Footer Styles */
.custom-footer {
  position: relative;
  width: calc(100% - 240px);
  margin-left: 240px;
  z-index: 1000;

  /* Saffron design tokens */
  border-top: 1px solid var(--color-line-subtle, #e6e6e6);
  background: var(--color-background-subtle, #fafafa);

  /* Minimal padding for compact design */
  padding: 12px 16px 8px;

  /* Enhanced smooth transitions */
  transition: width 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), margin-left 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    padding 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.custom-footer.full-width {
  width: calc(100% - 0.625rem);
  margin-left: 0.625rem;
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 1200px;
  margin: 0 auto;

  /* Smooth content transitions */
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Main footer row with logo and links */
.footer-main-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  /* Smooth layout transitions */
  transition: gap 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), flex-direction 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Footer left section (logo + copyright) */
.footer-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;

  /* Smooth section transitions */
  transition: align-items 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), gap 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Footer right section (links) */
.footer-right {
  display: flex;
  align-items: center;

  /* Smooth section transitions */
  transition: align-items 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    justify-content 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Thomson Reuters Logo Styling */
#tr-logo {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  /* Smooth logo positioning transitions */
  transition: justify-content 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    margin 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

#tr-logo svg {
  width: 193px;
  height: 26px;
  max-width: 100%;
  height: auto;

  /* Smooth transitions for interactions */
  transition: opacity 0.2s ease-in-out;
}

#tr-logo svg:hover {
  opacity: 0.8;
}

#tr-logo a {
  display: inline-block;
  text-decoration: none;
  border-radius: 4px;
  padding: 4px;
  margin: -4px;
  transition: opacity 0.2s ease-in-out;
}

#tr-logo a:hover {
  opacity: 0.8;
}

#tr-logo a:focus {
  outline: 2px solid var(--color-focus, #0066cc);
  outline-offset: 2px;
  background-color: rgba(0, 102, 204, 0.1);
}

#tr-logo a:active {
  transform: translateY(1px);
}

#tr-logo svg:focus {
  outline: none;
}

/* Footer Navigation */
.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  align-items: center;
}

.footer-link-item {
  display: inline-flex;
  align-items: center;
}

.footer-link-item:not(:last-child)::after {
  content: "•";
  margin: 0 8px;
  color: var(--color-text-subtle, #666);
  font-size: 12px;
  line-height: 1;
}

.footer-link {
  /* Saffron link styling */
  color: var(--color-link, #0066cc);
  text-decoration: none;
  font-size: 0.8125rem; /* 13px */
  font-weight: 400;
  line-height: 1.2;

  /* Compact padding */
  padding: 2px 0;

  /* Smooth transitions */
  transition: color 0.2s ease-in-out;

  /* Better click target */
  display: inline-block;
  position: relative;
}

.footer-link:hover {
  color: var(--color-link-hover, #0052a3);
  text-decoration: underline;
}

.footer-link:focus {
  outline: 2px solid var(--color-focus, #0066cc);
  outline-offset: 2px;
  border-radius: 2px;
}

.footer-link:active {
  color: var(--color-link-active, #003d7a);
}

/* Copyright section */
.footer-copyright {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  /* Smooth copyright positioning transitions */
  transition: justify-content 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.copyright-text {
  font-size: 0.75rem; /* 12px */
  color: var(--color-text-subtle, #666);
  line-height: 1.2;
  font-weight: 400;
  text-align: left;

  /* Smooth text alignment transitions */
  transition: text-align 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), font-size 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Responsive Design */
@media (max-width: 768px) {
  .custom-footer {
    padding: 10px 12px 6px;
  }

  .footer-content {
    gap: 4px;
  }

  /* Stack footer layout on tablets */
  .footer-main-row {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .footer-left {
    align-items: center;
  }

  .footer-copyright {
    justify-content: center;
  }

  .copyright-text {
    text-align: center;
  }

  /* Responsive logo styling for tablets */
  #tr-logo {
    justify-content: center;
  }

  #tr-logo svg {
    width: 154px; /* ~80% of original size */
    height: 21px;
  }

  .footer-links {
    justify-content: center;
    gap: 2px;
  }

  .footer-link {
    font-size: 0.75rem; /* 12px */
  }

  .footer-link-item:not(:last-child)::after {
    margin: 0 6px;
  }

  .copyright-text {
    font-size: 0.6875rem; /* 11px */
  }
}

@media (max-width: 480px) {
  /* Mobile logo styling */
  #tr-logo {
    margin-bottom: 8px;
  }

  #tr-logo svg {
    width: 135px; /* ~70% of original size */
    height: 18px;
  }

  .footer-links {
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .footer-link-item:not(:last-child)::after {
    display: none;
  }

  .footer-link {
    padding: 4px 8px;
    text-align: center;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .custom-footer {
    border-top: 2px solid;
  }

  .footer-link {
    font-weight: 500;
  }

  #tr-logo svg {
    filter: contrast(1.2);
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .custom-footer,
  .footer-content,
  .footer-main-row,
  .footer-left,
  .footer-right,
  #tr-logo,
  #tr-logo a,
  .footer-links,
  .footer-link,
  .footer-copyright,
  .copyright-text {
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/footer.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;;;;;;;;;;;GAWG;;AAEH,yBAAyB;AACzB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;;EAEb,0BAA0B;EAC1B,uDAAuD;EACvD,mDAAmD;;EAEnD,uCAAuC;EACvC,sBAAsB;;EAEtB,gCAAgC;EAChC;0GACwG;AAC1G;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;;EAEd,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;;EAET,8BAA8B;EAC9B,mHAAmH;AACrH;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;;EAEvB,+BAA+B;EAC/B,gHAAgH;AAClH;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;;EAEnB,+BAA+B;EAC/B;6DAC2D;AAC7D;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;;EAEnB,wCAAwC;EACxC;oDACkD;AACpD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;;EAEZ,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;EACrB,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,gBAAgB;;EAEhB,oBAAoB;EACpB,cAAc;;EAEd,uBAAuB;EACvB,kCAAkC;;EAElC,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;;EAE3B,6CAA6C;EAC7C,qEAAqE;AACvE;;AAEA;EACE,kBAAkB,EAAE,SAAS;EAC7B,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,sCAAsC;EACtC,qHAAqH;AACvH;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,wCAAwC;EACxC;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY,EAAE,0BAA0B;IACxC,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB,EAAE,SAAS;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB,EAAE,SAAS;EACjC;AACF;;AAEA;EACE,wBAAwB;EACxB;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY,EAAE,0BAA0B;IACxC,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;;;;;;;;IAWE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Legacy footer styles - kept for reference */\n/* .footer {\n  background-color: white;\n  padding: 18px;\n  height: 18px;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  box-shadow: 0 -1px 1px -1px gray;\n  display: flex;\n  z-index: 1000;\n} */\n\n/* Custom Footer Styles */\n.custom-footer {\n  position: relative;\n  width: calc(100% - 240px);\n  margin-left: 240px;\n  z-index: 1000;\n\n  /* Saffron design tokens */\n  border-top: 1px solid var(--color-line-subtle, #e6e6e6);\n  background: var(--color-background-subtle, #fafafa);\n\n  /* Minimal padding for compact design */\n  padding: 12px 16px 8px;\n\n  /* Enhanced smooth transitions */\n  transition: width 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), margin-left 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    padding 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.custom-footer.full-width {\n  width: calc(100% - 0.625rem);\n  margin-left: 0.625rem;\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  /* Smooth content transitions */\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Main footer row with logo and links */\n.footer-main-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n\n  /* Smooth layout transitions */\n  transition: gap 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), flex-direction 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Footer left section (logo + copyright) */\n.footer-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n\n  /* Smooth section transitions */\n  transition: align-items 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), gap 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Footer right section (links) */\n.footer-right {\n  display: flex;\n  align-items: center;\n\n  /* Smooth section transitions */\n  transition: align-items 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    justify-content 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Thomson Reuters Logo Styling */\n#tr-logo {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  /* Smooth logo positioning transitions */\n  transition: justify-content 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    margin 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n#tr-logo svg {\n  width: 193px;\n  height: 26px;\n  max-width: 100%;\n  height: auto;\n\n  /* Smooth transitions for interactions */\n  transition: opacity 0.2s ease-in-out;\n}\n\n#tr-logo svg:hover {\n  opacity: 0.8;\n}\n\n#tr-logo a {\n  display: inline-block;\n  text-decoration: none;\n  border-radius: 4px;\n  padding: 4px;\n  margin: -4px;\n  transition: opacity 0.2s ease-in-out;\n}\n\n#tr-logo a:hover {\n  opacity: 0.8;\n}\n\n#tr-logo a:focus {\n  outline: 2px solid var(--color-focus, #0066cc);\n  outline-offset: 2px;\n  background-color: rgba(0, 102, 204, 0.1);\n}\n\n#tr-logo a:active {\n  transform: translateY(1px);\n}\n\n#tr-logo svg:focus {\n  outline: none;\n}\n\n/* Footer Navigation */\n.footer-links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  align-items: center;\n}\n\n.footer-link-item {\n  display: inline-flex;\n  align-items: center;\n}\n\n.footer-link-item:not(:last-child)::after {\n  content: \"•\";\n  margin: 0 8px;\n  color: var(--color-text-subtle, #666);\n  font-size: 12px;\n  line-height: 1;\n}\n\n.footer-link {\n  /* Saffron link styling */\n  color: var(--color-link, #0066cc);\n  text-decoration: none;\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 400;\n  line-height: 1.2;\n\n  /* Compact padding */\n  padding: 2px 0;\n\n  /* Smooth transitions */\n  transition: color 0.2s ease-in-out;\n\n  /* Better click target */\n  display: inline-block;\n  position: relative;\n}\n\n.footer-link:hover {\n  color: var(--color-link-hover, #0052a3);\n  text-decoration: underline;\n}\n\n.footer-link:focus {\n  outline: 2px solid var(--color-focus, #0066cc);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.footer-link:active {\n  color: var(--color-link-active, #003d7a);\n}\n\n/* Copyright section */\n.footer-copyright {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  /* Smooth copyright positioning transitions */\n  transition: justify-content 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.copyright-text {\n  font-size: 0.75rem; /* 12px */\n  color: var(--color-text-subtle, #666);\n  line-height: 1.2;\n  font-weight: 400;\n  text-align: left;\n\n  /* Smooth text alignment transitions */\n  transition: text-align 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), font-size 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .custom-footer {\n    padding: 10px 12px 6px;\n  }\n\n  .footer-content {\n    gap: 4px;\n  }\n\n  /* Stack footer layout on tablets */\n  .footer-main-row {\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .footer-left {\n    align-items: center;\n  }\n\n  .footer-copyright {\n    justify-content: center;\n  }\n\n  .copyright-text {\n    text-align: center;\n  }\n\n  /* Responsive logo styling for tablets */\n  #tr-logo {\n    justify-content: center;\n  }\n\n  #tr-logo svg {\n    width: 154px; /* ~80% of original size */\n    height: 21px;\n  }\n\n  .footer-links {\n    justify-content: center;\n    gap: 2px;\n  }\n\n  .footer-link {\n    font-size: 0.75rem; /* 12px */\n  }\n\n  .footer-link-item:not(:last-child)::after {\n    margin: 0 6px;\n  }\n\n  .copyright-text {\n    font-size: 0.6875rem; /* 11px */\n  }\n}\n\n@media (max-width: 480px) {\n  /* Mobile logo styling */\n  #tr-logo {\n    margin-bottom: 8px;\n  }\n\n  #tr-logo svg {\n    width: 135px; /* ~70% of original size */\n    height: 18px;\n  }\n\n  .footer-links {\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .footer-link-item:not(:last-child)::after {\n    display: none;\n  }\n\n  .footer-link {\n    padding: 4px 8px;\n    text-align: center;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .custom-footer {\n    border-top: 2px solid;\n  }\n\n  .footer-link {\n    font-weight: 500;\n  }\n\n  #tr-logo svg {\n    filter: contrast(1.2);\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .custom-footer,\n  .footer-content,\n  .footer-main-row,\n  .footer-left,\n  .footer-right,\n  #tr-logo,\n  #tr-logo a,\n  .footer-links,\n  .footer-link,\n  .footer-copyright,\n  .copyright-text {\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
